import { Sun, Moon } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

export default function ThemeSwitcher() {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-switcher"
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            title={isDark ? "Light mode" : "Dark mode"}
            className="h-8 w-8 inline-flex items-center justify-center rounded-md border border-[var(--border-base)] bg-[var(--bg-card)] text-[var(--text-secondary)] hover:text-[var(--accent-hex)] hover:border-[var(--accent-border)] transition-colors"
        >
            {isDark ? <Sun className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
        </button>
    );
}
